var React = require('react');

function DownloadCircle (props) {
    return React.createElement("svg",props,[React.createElement("defs",{"key":0},React.createElement("style",null,".a{fill:none;stroke:#000;stroke-linecap:round;stroke-linejoin:round;stroke-width:1.5px;}")),React.createElement("polyline",{"className":"a","points":"8.25 14.25 12 18 15.75 14.25","key":1}),React.createElement("line",{"className":"a","x1":"12","y1":"6.75","x2":"12","y2":"18","key":2}),React.createElement("circle",{"className":"a","cx":"12","cy":"12","r":"11.25","key":3})]);
}

DownloadCircle.defaultProps = {"viewBox":"0 0 24 24"};

module.exports = DownloadCircle;

DownloadCircle.default = DownloadCircle;



//////////////////
// WEBPACK FOOTER
// ./src/components/icon/svgs/download-circle.svg
// module id = 1069
// module chunks = 0